import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ViewToggle: FunctionComponent<Props> = ({
    activeView,
    className = '',
    onViewChange,
    testId = TEST_ID
}) => {
    const { VIEW_BATTERIES, VIEW_DRONES } = useTranslation();
    const dronesActiveClass = activeView === 'drones' ? styles.isActive : '';
    const batteriesActiveClass = activeView === 'batteries' ? styles.isActive : '';

    return (
        <HorizontalContainer className={`${styles.viewToggle} ${className}`} testId={testId}>
            <Wrapper
                className={`${styles.viewTab} ${dronesActiveClass}`}
                onClick={() => onViewChange('drones')}>
                {VIEW_DRONES}
            </Wrapper>

            <Wrapper
                className={`${styles.viewTab} ${batteriesActiveClass}`}
                onClick={() => onViewChange('batteries')}>
                {VIEW_BATTERIES}
            </Wrapper>
        </HorizontalContainer>
    );
};

export default ViewToggle;
